import UsernameRenderer from './UsernameRenderer'

export default UsernameRenderer
